import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

// project import
import Drawer from './Drawer';
import Header from './Header';
import navigation from '../../menu-items';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT - MODERN ||============================== //

export default function DashboardLayout() {
  const theme = useTheme();
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', minHeight: '100vh' }}>
      <Header />
      {/* <Drawer /> */}
      <Box component="main" sx={{
        width: 'calc(100% - 260px)',
        flexGrow: 1,
        p: 0,
        backgroundColor: theme.palette.background.default
      }}>
        <Toolbar />
        <Breadcrumbs navigation={navigation} title />
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
